export default __webpack_public_path__ + "static/media/phone.415136bd.svg";